import { render, staticRenderFns } from "./ClockActivity.vue?vue&type=template&id=5f830784&"
import script from "./ClockActivity.vue?vue&type=script&lang=js&"
export * from "./ClockActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports